"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.productZhNameMap = exports.VERIFIED_STATUS = exports.PERMISSIONS = exports.STAFF_MAP = exports.ADMIN_ROLE = exports.ADMIN_ROLE_EN = exports.SOURCE_CATEGORY = exports.SOURCE_MAKER = void 0;
var SOURCE_MAKER;
(function (SOURCE_MAKER) {
    SOURCE_MAKER["CREATOR"] = "CREATOR";
    SOURCE_MAKER["TEAMWORKER"] = "TEAMWORKER"; // 资源协作者
})(SOURCE_MAKER || (exports.SOURCE_MAKER = SOURCE_MAKER = {}));
var SOURCE_CATEGORY;
(function (SOURCE_CATEGORY) {
    SOURCE_CATEGORY["WORKFLOW"] = "WORKFLOW";
    SOURCE_CATEGORY["PRODUCTQA"] = "PRODUCTQA"; // 产品问答
})(SOURCE_CATEGORY || (exports.SOURCE_CATEGORY = SOURCE_CATEGORY = {}));
var ADMIN_ROLE_EN;
(function (ADMIN_ROLE_EN) {
    ADMIN_ROLE_EN["ADMINISTRATOR"] = "ADMINISTRATOR";
    ADMIN_ROLE_EN["OPERATING_STAFF"] = "OPERATING_STAFF";
    ADMIN_ROLE_EN["PREVIEW_STAFF"] = "PREVIEW_STAFF";
})(ADMIN_ROLE_EN || (exports.ADMIN_ROLE_EN = ADMIN_ROLE_EN = {}));
var ADMIN_ROLE;
(function (ADMIN_ROLE) {
    ADMIN_ROLE["ADMINISTRATOR"] = "\u7BA1\u7406\u5458";
    ADMIN_ROLE["OPERATING_STAFF"] = "\u8FD0\u8425\u4EBA\u5458";
    ADMIN_ROLE["PREVIEW_STAFF"] = "\u9884\u89C8\u4EBA\u5458";
})(ADMIN_ROLE || (exports.ADMIN_ROLE = ADMIN_ROLE = {}));
exports.STAFF_MAP = (_a = {},
    _a[ADMIN_ROLE.ADMINISTRATOR] = ["可读", "可写"],
    _a[ADMIN_ROLE.OPERATING_STAFF] = ["可读", "可写"],
    _a[ADMIN_ROLE.PREVIEW_STAFF] = ["可读"],
    _a);
exports.PERMISSIONS = [
    {
        title: '流程',
        key: '0-0',
        children: [
            {
                title: '可读',
                key: '0-0-0',
                children: [
                    { title: '预览', key: '0-0-0-0' },
                ],
            },
            {
                title: '可写',
                key: '0-0-1',
                children: [
                    { title: '新建', key: '0-0-1-0' },
                    { title: '编辑', key: '0-0-1-1' },
                    { title: '删除', key: '0-0-1-2' },
                    { title: '复制', key: '0-0-1-3' },
                    { title: '保存', key: '0-0-1-4' },
                ],
            },
        ],
    },
    {
        title: '小程序',
        key: '0-1',
        children: [
            {
                title: '可读',
                key: '0-1-0',
                children: [
                    { title: '预览', key: '0-1-0-0' }
                ]
            },
            {
                title: '可写',
                key: '0-1-1',
                children: [
                    { title: '新建', key: '0-1-1-0' },
                    { title: '编辑', key: '0-1-1-1' },
                    { title: '保存', key: '0-1-1-2' },
                ]
            },
        ],
    },
    {
        title: '链接',
        key: '0-2',
        children: [
            {
                title: '可读',
                key: '0-2-0',
                children: [
                    { title: '预览', key: '0-2-0-0' }
                ]
            },
            {
                title: '可写',
                key: '0-2-1',
                children: [
                    { title: '新建', key: '0-2-1-0' },
                    { title: '编辑', key: '0-2-1-1' },
                    { title: '保存', key: '0-2-1-2' },
                ]
            }
        ]
    },
    {
        title: '视频号',
        key: '0-3',
        children: [
            {
                title: '可读',
                key: '0-3-0',
                children: [
                    { title: '预览', key: '0-3-0-0' }
                ]
            },
            {
                title: '可写',
                key: '0-3-1',
                children: [
                    { title: '新建', key: '0-3-1-0' },
                    { title: '编辑', key: '0-3-1-1' },
                    { title: '保存', key: '0-3-1-2' },
                ]
            }
        ]
    },
    {
        title: '小红书-官号',
        key: '1-0',
        children: [
            {
                title: '可读',
                key: '1-0-0',
                children: [
                    { title: '预览', key: '1-0-0-0' }
                ]
            },
            {
                title: '可写',
                key: '1-0-1',
                children: [
                    { title: '新建', key: '1-0-1-0' },
                    { title: '编辑', key: '1-0-1-1' },
                    { title: '保存', key: '1-0-1-2' },
                    { title: '机器人操作', key: '1-0-1-3' },
                ]
            }
        ]
    },
    {
        title: '小红书-二维码',
        key: '1-1',
        children: [
            {
                title: '可读',
                key: '1-1-0',
                children: [
                    { title: '预览', key: '1-1-0-0' }
                ]
            },
            {
                title: '可写',
                key: '1-1-1',
                children: [
                    { title: '新建', key: '1-1-1-0' },
                    { title: '编辑', key: '1-1-1-1' },
                    { title: '保存', key: '1-1-1-2' },
                ]
            }
        ]
    },
    {
        title: '权限管理',
        key: '2-0',
        children: [
            {
                title: '可读',
                key: '2-0-0',
                children: [
                    { title: '预览', key: '2-0-0-0' }
                ]
            },
            {
                title: '可写',
                key: '2-0-1',
                children: [
                    { title: '编辑', key: '2-0-1-0' },
                    { title: '保存', key: '2-0-1-1' },
                ]
            }
        ]
    },
    {
        title: '知识库-产品问答',
        key: '3-0',
        children: [
            {
                title: '可读',
                key: '3-0-0',
                children: [
                    { title: '预览', key: '3-0-0-0' }
                ]
            },
            {
                title: '可写',
                key: '3-0-1',
                children: [
                    { title: '编辑', key: '3-0-1-0' },
                    { title: '保存', key: '3-0-1-1' },
                    { title: '删除', key: '3-0-1-2' },
                ]
            }
        ]
    },
    {
        title: '知识库-标签',
        key: '3-1',
        children: [
            {
                title: '可读',
                key: '3-1-0',
                children: [
                    { title: '预览', key: '3-1-0-0' }
                ]
            },
            {
                title: '可写',
                key: '3-1-1',
                children: [
                    { title: '编辑', key: '3-1-1-0' },
                    { title: '保存', key: '3-1-1-1' },
                    { title: '删除', key: '3-1-1-2' },
                ]
            }
        ]
    },
];
exports.VERIFIED_STATUS = [
    { value: "PENDING_SUBMISSION", label: "待提交", color: "default" },
    { value: "PENDING_REVIEW", label: "待复核", color: "processing" },
    { value: "STORED", label: "已落库", color: "success" },
    { value: "PENDING_MODIFICATION", label: "待修改", color: "error" },
];
exports.productZhNameMap = {
    "mdd": "麦兜兜",
    "alza": "安联臻爱",
    "xnz": "小哪吒",
    "xxss": "小小神兽",
    "xss": "小神兽",
};
var Config = /** @class */ (function () {
    function Config() {
        this.databaseUrl = 'postgresql://postgres:insnail@127.0.0.1:5432/bb8';
        this.msgSendUrl = 'https://ex-api.botorange.com/message/send';
        this.botToken = '6264fb9918f39df4d82f1b91';
        this.jukebaoToken = '026df4e7b90b4bacaec4685735f88308';
        this.helperSysUserId = '11111';
    }
    return Config;
}());
exports.default = new Config();
//# sourceMappingURL=config.js.map